import React from 'react'
import Label from "components/general/Label";
import Status from "components/presentation/Status"
import { Score as ScoreGlobal } from "components/presentation/Score"
import Competitor from 'components/presentation/Competitor';
import Noc from 'components/presentation/Noc';
import { Stack } from 'react-bootstrap';
import SportCode, { getSportCodeObject } from '../SportCode';
import Discipline from 'components/presentation/Discipline';
import Medal from 'components/presentation/Medal';
import DateTime from 'components/presentation/DateTime';
import { SCREEN_TYPE, getDateTimeFormat, sortDataByField } from 'helpers/utils';
import { Link } from 'react-router-dom';
import { getEventRSC } from 'helpers/rsc';
import { useGetConfigSports } from 'helpers/commonCodes';
import ScheduleDataTime from 'components/presentation/ScheduleDataTime';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useQueryClient } from '@tanstack/react-query';
import { isFinishedStatus } from 'helpers/status';

export function ColumnTime({
  disableSort = false,
  label = "HeaderTime"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => {
        return (props?.startDate + props?.order)
      },
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: 'Time',
      Cell: (props) => {
        const row = props.cell.row.original;
        return (<ScheduleDataTime data={row} />)
      }
    }
  )
}

export function ColumnEvent({
  disableSort = false,
  label = "HeaderEvent",
  paramsURL = {},
  getURL = {}
}) {
  const params = { ...paramsURL }
  return (
    {
      Header: <Label data={label} />,
      accessor: 'eventUnit.longDescription',
      className: 'schedule-event',
      headerClassName: 'schedule-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        const row = props.cell.row.original;
        const unitNumber = !row?.hideUnitNumber && row?.unitNum ? '#' + row.unitNum?.padStart(2, '0') : '';
        const medal = row?.eventUnit?.medal;
        const hasLink = (row?.eventUnit?.code?.indexOf('TRNO') === -1
          && row?.eventUnit?.code?.indexOf('TMRY') === -1
          && row?.status?.code !== "CANCELLED"
          && (row?.eventUnit?.type !== "NONE"))

        params["mirs_discipline"] = row?.discipline?.code;
        const rsc = row?.eventUnit?.resultRSC || row?.eventUnit?.code;
        params["mirs_event"] = getEventRSC(rsc);
        params["mirs_rsc"] = rsc;
        const url = getURL(params, "results");
        return (<Stack direction='horizontal'>
          <div className='text-wrap'>
            {medal > 0 && <span className="me-2" >
              <Medal code={`${medal}`} />
            </span>
            }
            <span>
              {(hasLink)
                ? <Link to={url} >{row?.eventUnit?.longDescription}</Link>
                : row?.eventUnit?.longDescription
              }
            </span>
          </div>
          {unitNumber &&
            <span className='ms-auto'>{unitNumber}</span>
          }
        </Stack>)
      }
    }
  )
}

export function ColumnEventWithCompetitor({
  disableSort = false,
  label = "HeaderEvent",
  paramsURL = {},
  getURL = {},
  isH2H = false
}) {
  const params = { ...paramsURL };

  return (
    {
      Header: <Label data={label} />,
      accessor: 'eventUnit.longDescription',
      className: 'schedule-event',
      headerClassName: 'schedule-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        const row = props.cell.row.original
        const eventDesc = row?.eventUnit?.longDescription
        const isEventUnitH2H = row?.eventUnit?.type.startsWith("H");
        const isDisciplineH2H = isH2H;
        const discipline = row?.discipline?.code
        const rsc = row?.eventUnit?.resultRSC || row?.eventUnit?.code;
        const isGoldMedal = row?.eventUnit?.medal === 1;
        const isBronzeMedal = (row?.eventUnit?.medal === 3);
        let medallist = row?.eventUnit?.phase?.event?.medallists;
        const unitNumber = !row?.hideUnitNumber && row?.unitNum ? '#' + row.unitNum?.toString().padStart(2, '0') : '';
        const medal = row?.eventUnit?.medal;
        medallist?.sort((a, b) => (a?.medal_type - b?.medal_type === 0) || (a?.competitor_order - b?.competitor_order));
        if (!isDisciplineH2H && isEventUnitH2H) {
          //discipline config is not H2H
          // event unit is H2H , for ex shooting mixed team
          // display medals with event_unit_code equals the eventUnitCode of the entire row
          medallist = medallist?.filter(md => md?.event_unit_code === row?.eventUnit?.code);
        };
        const hasMedal = (isGoldMedal || (isBronzeMedal && !isDisciplineH2H && isEventUnitH2H)) && medallist?.length;
        const hasLink = (row?.eventUnit?.code?.indexOf('TRNO') === -1
          && row?.eventUnit?.code?.indexOf('TMRY') === -1
          && row?.status?.code !== "CANCELLED"
          && (row?.eventUnit?.type !== "NONE"))

        /* if (getLevelRSC(params["mirs_rsc"]) === "EVENT" || !rsc) {
          params["mirs_event"] = rsc
          params["mirs_rsc"] = undefined
        } else {
          //Phase or unit
          params["mirs_event"] = getEventRSC(rsc)
          params["mirs_rsc"] = rsc
        } */
        params["mirs_event"] = getEventRSC(rsc);
        params["mirs_rsc"] = rsc;
        params["mirs_discipline"] = discipline;
        const url = getURL(params, "results");

        return (
          <Stack direction='vertical'>
            <Stack direction='horizontal'>
              <div className='text-wrap'>
                {medal > 0 && <span className="me-2" >
                  <Medal code={`${medal}`} />
                </span>
                }
                <span>
                  {(hasLink)
                    ? <Link to={url} >{eventDesc}</Link>
                    : eventDesc
                  }
                </span>
              </div>
              {unitNumber &&
                <span className='ms-auto'>{unitNumber}</span>
              }
            </Stack>
            {(isDisciplineH2H && isEventUnitH2H)
              ?
              <Stack direction='horizontal'>
                <Stack direction='vertical' className='schedule-competitor w-70'>
                  {(row?.result?.items || row?.start)?.map((item) => {
                    const boldWinner = item?.resultWLT?.trim() === "W" ? "fw-bold" : "";
                    return (
                      <div className={boldWinner} key={`participant-${rsc}-${item?.participant?.code}`}>
                        <Competitor {...item?.participant} noLink={true} hidePicture={true} />
                      </div>
                    )
                  })}
                </Stack>
                <Stack direction='vertical' className='schedule-result'>
                  {row?.result?.items?.map((item) => {
                    return (
                      <ScoreGlobal resultJson={item?.resultDataText} discipline={discipline} key={`score-${rsc}-${item?.sortOrder}`} extendedInfos={row?.result?.extendedInfos}/>
                    )
                  })}
                </Stack>
              </Stack>
              : hasMedal ?
                <Stack direction='vertical' gap={1}>
                  {medallist?.map((m, index) => {
                    return (
                      <Stack direction='horizontal' key={`medalist-${rsc}-${m?.medal_type}-${index}`}>
                        <div className='me-2'>
                          <Medal code={m?.medal_type} showImage={true} />
                        </div>
                        <div className="fw-bold"><Noc {...m?.participant?.organisation} showOnlyImage={true} /></div>
                        <Competitor {...m?.participant} noLink={true} hideNoc={true} hidePicture={true} onlyShortName />
                      </Stack>
                    )
                  })}
                </Stack>
                : isEventUnitH2H || ["schedulebynoc", "bios"].includes(params["mirs_path"]) ?
                  <Stack direction='vertical' className='schedule-competitor'>
                    {(row?.result?.items || row?.start)?.map((item) => {
                      const boldWinner = item?.resultWLT?.trim() === "W" ? "fw-bold" : "";
                      return (
                        <div className={boldWinner} key={`participant-${rsc}-${item?.participant?.code}`}>
                          <Competitor {...item?.participant} noLink={true} hidePicture={true} />
                        </div>
                      )
                    })}
                  </Stack> : ""
            }
          </Stack>
        )
      }
    }
  )
}

export function ColumnCompetitor({
  label = "",
  paramsURL = {},
  isH2H = false
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-competitor',
      headerClassName: 'schedule-competitor',
      disableSortBy: true,
      id: 'Competitor',
      Cell: (props) => {
        const { mirs_path, mirs_discipline, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
        const queryClient = useQueryClient();
        const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
        const row = props.cell.row.original;
        const isDisciplineH2H = isH2H;
        const isEventUnitH2H = row?.eventUnit?.type.startsWith("H");
        const isGoldMedal = (row?.eventUnit?.medal === 1);
        const isBronzeMedal = (row?.eventUnit?.medal === 3);
        const rsc = row?.code
        let medallist = row?.eventUnit?.phase?.event?.medallists;
        medallist?.sort((a, b) => (a?.medal_type - b?.medal_type) || (a?.competitor_order - b?.competitor_order));
        if (!isDisciplineH2H && isEventUnitH2H) {
          //discipline config is not H2H
          // event unit is H2H , for ex shooting mixed team
          medallist = medallist?.filter(md => md?.event_unit_code === row?.eventUnit?.code);
        };
        const hasMedal = (isGoldMedal || (isBronzeMedal && !isDisciplineH2H && isEventUnitH2H)) && medallist?.length;
        return (
          <>
            {(isDisciplineH2H && isEventUnitH2H)
              ?
              ((row?.result?.items)?.sort((a, b) => a.startSortOrder - b.startSortOrder) || (row?.start)?.sort((a, b) => a.startOrder - b.startOrder))?.map((item) => {
                const boldWinner = item?.resultWLT?.trim() === "W" && "fw-bold";
                let competitorCompetitorPlace = getSportCodeObject(dataSportCodes, mirs_discipline, '@CompetitorPlace', item?.athleteCode)?.description
                competitorCompetitorPlace = competitorCompetitorPlace ? competitorCompetitorPlace : getSportCodeObject(dataSportCodes, mirs_discipline, '@CompetitorPlace', item?.teamCode)?.description
                let out = competitorCompetitorPlace ? competitorCompetitorPlace : <Competitor {...item?.participant} hideNoc={true} noLink={true} hidePicture={true} key={`participant-${rsc}-${item?.participant?.code}`} />

                return (
                  <Stack className={boldWinner} direction='horizontal' key={`participant-${rsc}-${item?.participant?.code}`}>
                    <div className="d-none d-md-inline"><Noc {...item?.participant?.organisation} /></div>
                    {out}
                  </Stack>
                )
              })
              :
              hasMedal
                ? medallist?.map((m, index) => {
                  let competitorCompetitorPlace = getSportCodeObject(dataSportCodes, mirs_discipline, '@CompetitorPlace', m?.athleteCode)?.description
                  competitorCompetitorPlace = competitorCompetitorPlace ? competitorCompetitorPlace : getSportCodeObject(dataSportCodes, mirs_discipline, '@CompetitorPlace', m?.teamCode)?.description
                  let out = competitorCompetitorPlace ? competitorCompetitorPlace : <Competitor {...m?.participant} hideNoc={true} noLink={true} hidePicture={true} key={`participant-${rsc}-${m?.participant?.code}`} />

                  return (
                    <Stack direction='horizontal' key={`medalist-${rsc}-${m?.medal_type}-${index}`}>
                      <div className='me-2'>
                        <Medal code={m?.medal_type} showImage={true} />
                      </div>
                      <div className="fw-bold"><Noc {...m?.participant?.organisation} /></div>
                      {out}
                    </Stack>
                  )
                })
                : isEventUnitH2H || ["schedulebynoc", "bios"].includes(mirs_path) ? (row?.result?.items?.sort((a, b) => a.startSortOrder - b.startSortOrder) || (row?.start)?.sort((a, b) => a.startOrder - b.startOrder))?.map((item) => {
                  let competitorCompetitorPlace = getSportCodeObject(dataSportCodes, mirs_discipline, '@CompetitorPlace', item?.athleteCode)?.description
                  competitorCompetitorPlace = competitorCompetitorPlace ? competitorCompetitorPlace : getSportCodeObject(dataSportCodes, mirs_discipline, '@CompetitorPlace', item?.teamCode)?.description
                  let out = competitorCompetitorPlace ? competitorCompetitorPlace : <Competitor {...item?.participant} hideNoc={true} noLink={true} hidePicture={true} key={`participant-${rsc}-${item?.participant?.code}`} />
                  return (
                    <Stack direction='horizontal' key={`participant-${rsc}-${item?.participant?.code}`}>
                      <div className="d-none d-md-inline"><Noc {...item?.participant?.organisation} /></div>
                      {out}
                    </Stack>
                  )
                }) : ""
            }
          </>
        )
      }
    }
  )
}

export function ColumnResult({
  label = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-result',
      headerClassName: 'schedule-result',
      disableSortBy: true,
      id: 'Result',
      Cell: (props) => {
        const row = props.cell.row.original
        const isH2H = row?.eventUnit?.type?.startsWith('H')
        const discipline = row?.discipline?.code
        const rsc = row?.code
        const sortedResults = row?.result?.items?.sort((a, b) => a.startSortOrder - b.startSortOrder)
        const extendedInfos = row.result?.extendedInfos;
        const resultStatus = row?.result?.status?.code;
        const isFinished = isFinishedStatus(resultStatus);

        let comp = [];
        let finihsMatch;
        let resultObj;
        if (isH2H) {
          sortedResults?.forEach((item, index) => {
            if (item?.resultDataText) {
              resultObj = item?.resultDataText ? JSON.parse(item?.resultDataText) : {};
              if (resultObj.extra) {
                finihsMatch = resultObj?.extra?.pso ? resultObj?.extra?.pso : resultObj?.extra?.aet
              }
            }
            comp.push(<ScoreGlobal competitorPos={item.startSortOrder} resultJson={item?.resultDataText} discipline={discipline} screen={SCREEN_TYPE.SCHEDULE} key={`score-${rsc}-${index}`} extendedInfos={extendedInfos} />)
          })
        }

        let score;
        if (finihsMatch && isFinished) {
          score = (
            <div className="d-flex flex-row">
              <div className='w-70'>{comp}</div>
              <div className="my-auto fw-bold w-30"><abbr title={Label({ data: finihsMatch, noHtml: true })}>{finihsMatch}</abbr></div>
            </div>
          )
        } else {
          score = comp
        }

        return (
          <>
            {score}
          </>
        )
      }
    }
  )
}

export function ColumnOT({
  label = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      disableSortBy: true,
      id: 'OT',
      Cell: (props) => {
        const overTime = props.cell.row.original?.result?.periods?.filter(period => period.p_code === "OT");
        if (overTime?.length) {
          return (
            <SportCode code="OT" entity="@Period" abbr={true} />
          )
        }
      }
    }
  )
}

export function ColumnLocation({
  disableSort = false,
  label = "HeaderLocation"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'location.locationOrder',
      className: 'schedule-location',
      headerClassName: 'schedule-location',
      disableSortBy: disableSort,
      id: 'Location',
      Cell: (props) => {
        return (
          props.cell.row.original?.location?.description
        )
      }
    }
  )
}

export function ColumnLocationNOC({
  disableSort = false,
  label = "HeaderLocation"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'location.shortDescription',
      className: 'schedule-location',
      headerClassName: 'schedule-location',
      disableSortBy: disableSort,
      id: 'Location',
      Cell: (props) => {
        return (
          props.cell.row.original?.location?.description
        )
      }
    }
  )
}

export function ColumnSession({
  disableSort = false,
  label = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'session.startDate',
      className: 'schedule-session',
      headerClassName: 'schedule-session',
      disableSortBy: disableSort,
      id: 'Session',
      Cell: (props) => {
        const row = props.cell.row.original
        const discipline = row?.discipline?.code
        return (
          <Stack direction='horizontal'>
            <span className="px-2">
              <SportCode code={row?.session?.code} discipline={discipline} entity="@Session" />
            </span>
            <span className="px-1">
              <DateTime format="H:mm" datetime={row?.session?.startDate} />
            </span>
            <span className="px-1">-</span>
            <span className="px-1">
              <DateTime format="H:mm" datetime={row?.session?.endDate} />
            </span>
          </Stack>
        )
      }
    }
  )
}

export function ColumnStatus({
  label = "HeaderStatus"
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-status',
      headerClassName: 'schedule-status',
      disableSortBy: true,
      id: 'Status',
      Cell: (props) => {
        const resultStatus = props.cell.row.original?.result?.status?.code
        const scheduleStatus = props.cell.row.original?.status?.code
        return (
          <Status typeToPrint='schedule' scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
        )
      }
    }
  )
}

export function ColumnDiscipline({
  disableSort = false,
  showDesc = false,
  label = "HeaderDiscipline"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => (props?.discipline?.description?.toUpperCase()),
      className: 'schedule-discipline',
      headerClassName: 'schedule-discipline',
      disableSortBy: disableSort,
      id: 'Discipline',
      Cell: (props) => {
        const row = props.cell.row.original
        const code = row?.discipline?.code
        const description = row?.discipline?.description
        return (
          <Discipline code={code} description={description} showDescription={showDesc} />
        )
      }
    }
  )
}
export function ColumnMedalDiscipline({
  disableSort = false,
  showDesc = false,
  label = "HeaderDiscipline",
  isAlphabeticalSort = true
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => {
        return isAlphabeticalSort ? props?.discipline?.description?.toLowerCase() : props?.discipline?.descriptionOrder;
      },
      sortType: isAlphabeticalSort ? 'absoluteOrderString' : 'absoluteOrderNumber',
      className: 'medals-discipline',
      headerClassName: 'medals-discipline',
      disableSortBy: disableSort,
      id: 'Discipline',
      multiSort: [{ id: 'Discipline' }, { id: 'Event', desc: false }, { id: 'Medal', desc: false }, { id: 'NOC', desc: false }, { id: 'Competitor', desc: false }],
      Cell: (props) => {
        const row = props.cell.row.original
        const code = row?.discipline?.code
        const description = row?.discipline?.description
        return (
          <Discipline code={code} description={description} showDescription={showDesc} />
        )
      }
    }
  )
}

export function ColumnDisciplineMobile({
  disableSort = false,
  showDesc = false,
  label = "HeaderDiscipline"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => (props?.discipline?.description?.toUpperCase()),
      className: 'schedule-discipline',
      headerClassName: 'schedule-discipline',
      disableSortBy: disableSort,
      id: 'Discipline',
      Cell: (props) => {
        const row = props.cell.row.original
        const code = row?.discipline?.code
        const description = row?.discipline?.description
        return (
          <Discipline code={code} description={description} showDescription={showDesc} />
        )
      }
    }
  )
}


export function ColumnDateTime({
  disableSort = false,
  label = "HeaderDate"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startDate',
      className: 'schedule-time',
      headerClassName: 'schedule-time w-5',
      disableSortBy: disableSort,
      id: 'Time',
      Cell: (props) => {
        const row = props.cell.row.original
        const format = getDateTimeFormat("DayMonthShort");
        // <DateTime format="MMM Do H:mm" datetime={row?.startDate} />
        return (
          <DateTime format={format} datetime={row?.startDate} />
        )
      }
    }
  )
}

export function ColumnDateTimeNOC({
  disableSort = false,
  label = "HeaderTime"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startDate',
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: 'Time',
      Cell: (props) => {
        const row = props.cell.row.original
        const discipline = row?.discipline?.code
        const hideEnd = row?.hideEndDate === false ? false : true
        const startText = row.startText
        return (
          <>
            <div className='d-flex flex-column'>

              {startText &&
                <SportCode code={startText} discipline={discipline} entity="@StartText" />
              }
              {
                <DateTime format="H:mm" datetime={row?.startDate} />
              }
              {//!hideEnd &&
                // <>
                //   <Label data="LabelFinishOn" />&nbsp;
                //   <Moment tz={globalProps.timezone} format="MMM Do">
                //     {row?.endDate}
                //   </Moment>
                // </>
              }
            </div>
          </>
        )
      }
    }
  )
}

export function ColumnDate({
  disableSort = false,
  label = "HeaderDate"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startDate',
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: 'Date',
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <DateTime format="MMM Do" datetime={row?.startDate} />
        )
      }
    }
  )
}

export function ColumnNocCompetitor({
  label = "",
  nocToShow = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-competitor',
      headerClassName: 'schedule-competitor',
      disableSortBy: true,
      id: 'Competitor',
      Cell: (props) => {
        const row = props.cell.row.original
        const rsc = row?.code
        const isH2H = row?.eventUnit?.type.startsWith("H")
        return (
          <>
            {row?.result?.items?.map((item) => {
              if (isH2H || (!isH2H && item?.participant?.organisation?.code == nocToShow)) {
                return (
                  <Stack direction='horizontal' key={`participant-${rsc}-${item?.participant?.code}`}>
                    <div className="d-none d-md-inline"><Noc {...item?.participant?.organisation} /></div>
                    <Competitor {...item?.participant} hideNoc={true} hidePicture={true} />
                  </Stack>
                )
              }
            })}
          </>
        )
      }
    }
  )
}

export function ColumnNoc({

  disableSort = false,
  className = 'text-start',
  headerClassName = 'text-start w-20',
  label = 'HeaderNOC',
  remove = false
}) {

  return (
    {
      Header: <Label data={label} />,
      id: 'NOC',
      accessor: (props) => props?.participant?.organisation?.description?.toUpperCase(),
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      remove: remove,
      Cell: (props) => {
        const row = props.cell.row.original
        let data = row?.participant?.organisation
        return (<Noc {...data} showLongDesc={true} />)
      }
    }
  )
}

export function ColumnMedalNoc({
  disableSort = false,
  className = 'text-start',
  headerClassName = 'text-start w-20',
  label = 'HeaderNOC',
  remove = false
}) {

  return (
    {
      Header: <Label data={label} />,
      id: 'NOC',
      accessor: (props) => props?.participant?.organisation?.descriptionOrder,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      remove: remove,
      Cell: (props) => {
        const row = props.cell.row.original;
        let data = row?.participant?.organisation;
        return (<Noc {...data} />);
      }
    }
  )
}

export function ColumnMedal({
  disableSort = false,
  label = "HeaderMedal"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'medal_type',
      className: 'medallist-medal',
      headerClassName: 'medallist-medal',
      disableSortBy: disableSort,
      id: 'Medal',
      multiSort: [{ id: 'Medal' }, { id: 'Discipline', desc: false }, { id: 'Event', desc: false }, { id: 'NOC', desc: false }, { id: 'Competitor', desc: false }],
      Cell: (props) => {
        return (
          <Medal code={props.cell.row.original?.medal_type} />
        )
      }
    }
  )
}

export function ColumnMedalEvent({
  disableSort = false,
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: props => props?.event?.order,
      className: 'medals-event',
      headerClassName: 'medals-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        return (
          props.cell.row.original?.event?.longDescription
        )
      }
    }
  )
}

export function ColumnMedalEventWithCompetitor({
  disableSort = false,
  label = "HeaderEvent",
  hidePicture = true
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: props => props?.event?.order,
      className: 'medals-event',
      headerClassName: 'medals-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        const row = props.cell.row.original
        const eventDesc = row?.event?.longDescription;
        return (
          <Stack direction='vertical'>
            <div>{eventDesc}</div>
            <Stack direction='horizontal'>
              <Competitor {...row?.participant} hideNoc={false} hideNocName={false} hidePicture={hidePicture} key={`participant-${row?.participant?.code}`} />
            </Stack>
          </Stack>
        )
      }
    }
  )
}

export function ColumnMedalParticipant({
  disableSort = false,
  label = "HeaderName"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => props?.participant?.name?.toLowerCase(),
      className: 'medal-competitor',
      headerClassName: 'medal-competitor',
      disableSortBy: disableSort,
      id: 'Competitor',
      multiSort: [{ id: 'Competitor' }, { id: 'Medal', desc: false }, { id: 'Discipline', desc: false }, { id: 'Event', desc: false }],
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          //   props.cell.row.original?.participant?.name
          <>
            <Stack direction='horizontal' key={`participant-${row?.participant?.code}`}>
              <Competitor {...row?.participant} alwaysNoc={false} hideNoc={true} hidePicture={true} key={`participant-${row?.participant?.code}`} />
            </Stack>
          </>
        )
      }
    }
  )
}

export function ColumnMedalCompetitor({
  label = "LabelCompetitor",
  disableSort = false
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => props?.participant?.name?.toUpperCase(),
      className: 'medal-competitor',
      headerClassName: 'medal-competitor',
      disableSortBy: disableSort,
      id: 'Competitor',
      multiSort: [{ id: 'Competitor' }, { id: 'Medal', desc: false }, { id: 'Discipline', desc: false }, { id: 'Event', desc: false }, { id: 'NOC', desc: false }],
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <>
            <Stack direction='horizontal' key={`participant-${row?.participant?.code}`}>

              <Competitor {...row?.participant} alwaysNoc={false} hideNoc={true} hidePicture={false} key={`participant-${row?.participant?.code}`} />
            </Stack>
          </>
        )
      }
    }
  )
}

export function ColumnSport({
  disableSort = false,
  label = "HeaderSport"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => (props?.discipline?.description?.toUpperCase()),
      className: 'schedule-discipline',
      headerClassName: 'schedule-discipline',
      disableSortBy: disableSort,
      id: 'Discipline',
      Cell: (props) => {
        return (

          <Discipline code={props.cell.row.original?.discipline?.code} description={props.cell.row.original?.discipline?.description} />
        )
      }
    }
  )
}

export function ColumnStartTime({
  disableSort = false,
  label = "HeaderStartTime",
  id = "Time"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startDate',
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: id,
      Cell: (props) => {
        const row = props.cell.row.original
        const discipline = row?.discipline?.code
        const hideEnd = row?.hideEndDate === false ? false : true
        const startText = row.startText
        return (
          <>
            <div className='d-flex flex-column'>

              {startText &&
                <SportCode code={startText} discipline={discipline} entity="@StartText" />
              }
              {
                <DateTime format="H:mm" datetime={row?.startDate} />
              }
              {//!hideEnd &&
                // <>
                //   <Label data="LabelFinishOn" />&nbsp;
                //   <Moment tz={globalProps.timezone} format="MMM Do">
                //     {row?.endDate}
                //   </Moment>
                // </>
              }
            </div>
          </>
        )
      }
    }
  )
}
